module.exports = __webpack_public_path__ + "img/jh.da8a46a9.svg";